import React, { useState, useEffect } from 'react'
import ListBrandsFilters from "./ListBrandsFilters"
import ListBrandsTable from "./ListBrandsTable"
import ListBrandsProvider from "./ListBrandsProvider"
import UseDebounce from "../helpers/UseDebounce"
import { getExportBrands, getListBrands } from "../../../services/api/apiBrands"
import ButtonAddBrands from "./button/ButtonAddBrands"
import EditBrandsPopup from "./EditBrandsPopup"
import { Link } from "react-router-dom"
import moment from 'moment'
import {createJobExport} from '../../helpers/createJobExport'
import downloadFileFromData from '../../helpers/downloadFileFromData'
const ListBrandsPage = () => {
    const [page, _setPage] = useState(1)
    const [limit, _setLimit] = useState(50)
    const [loading, _setLoading] = useState(true)
    const [total, _setTotal] = useState(0)
    const [error, _setError] = useState('')
    const [brandLists, _setBrandLists] = useState([])
    const [filters, _setFilters] = useState({})
    const [isOpenEdit, _setOpenEdit] = useState(false)
    const [brandName, _setBrandName] = useState('')
    const [store, _setStore] = useState('')
    const [brandId, _setBrandId] = useState('')

    const debouncedSearchStore = filters.store === '' ? UseDebounce(filters.store, 0) : UseDebounce(filters.store, 1000)
    const debouncedSearchBrandName = filters.name === '' ? UseDebounce(filters.name, 0) : UseDebounce(filters.name, 1000)

    const _hadleSetState = (filters) => {
        _setFilters(filters)
        _setPage(1)
    }

    const _handleClickEditBrand = (currentId, currentBrand, currentStore) => {
        _setOpenEdit(true)
        _setBrandId(currentId)
        _setBrandName(currentBrand)
        _setStore(currentStore)
    }

    const _handleTogglePopupEdit = (isOpenEdit) => {
        _setOpenEdit(false)
    }

    const _fetchListBrands = async () => {
        try {
            _setLoading(true)
            _setError('')

            const filterKey = Object.keys(filters)[0];
            const filterValue = Object.values(filters)[0];

            const payload = {
                [filterKey]: filterValue,
                limit: limit,
                page: page
            }

            const { data, success, message } = await getListBrands(payload)

            if (!success) {
                _setLoading(false)
                _setBrandLists([])
                return _setError(message)
            }

            const { Brands, total } = data

            _setBrandLists(Brands)

            _setLoading(false)
            _setError('')
            _setTotal(total)
        } catch (e) {
            _setLoading(false)
            _setError(e.message)
        }
    }

    const _handleSetPage = (page) => {
        _setPage(page)
    }

    const _handleSetSize = (size) => {
        _setLimit(size)
    }

    const handleExportBrands = async() => {
        try {
            const filterKey = Object.keys(filters)[0];
            const filterValue = Object.values(filters)[0];

            const payload = {
                [filterKey]: filterValue,
                limit: limit,
                page: page
            }
            const {data: res} = await getExportBrands(payload)
            if (typeof res !== 'string') {
                const { success, message: mess, data } = res
                if (!success) throw new Error(mess)

                if (Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            } else {
                downloadFileFromData(res, { filename: `Brands-${moment().format('YYYY-MM-DD')}.csv` })
            }
        } catch (e) {
            alert(e.toString())
        }

    }

    useEffect(() => {
        _fetchListBrands()
    }, [debouncedSearchBrandName, debouncedSearchStore, limit, page])

    return (
        <ListBrandsProvider filters={filters} setState={_hadleSetState} loadBrandsList={_fetchListBrands} handleClickEditBrand={_handleClickEditBrand}>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex flex-column">
                    <div className="ReturnPage mb-2">
                        <Link to={'/brands-rule'} className="txt-16">
                            <i className="fa fa-chevron-left mr-2" /> List brands rule
                        </Link>
                    </div>
                    <h1 className="card-title">Brands Management</h1>
                </div>
                {/*<Button class="AddBrandNew" onClick={_handleClickAddBrands}>Add brands</Button>*/}
                {/*<AddBrandsPopup isOpen={isOpen} onTogglePopup={_handleClickAddBrands} onAddBrand={_handleAddBrands}/>*/}

                <div className="actions d-flex">
                    <button
                        className='btn btn-outline-primary mr-2'
                        onClick={handleExportBrands}
                    >
                        Export
                    </button>

                    <ButtonAddBrands />
                </div>
            </div>
            <div className="card SettingShippingRulePage">
                <div className="card-body">
                    <div className="ShippingRuleFilters">
                        <ListBrandsFilters />
                    </div>
                    <div>
                        {error && <div className="text-danger">{error}</div>}
                        <ListBrandsTable loading={loading} limit={limit} page={page} total={total} onChangeSize={_handleSetSize} onChangePage={_handleSetPage} brandLists={brandLists} />
                        <EditBrandsPopup isOpen={isOpenEdit} brandId={brandId} brandName={brandName} store={store} onTogglePopup={_handleTogglePopupEdit} reLoadBrandsList={_fetchListBrands} />
                    </div>
                </div>
            </div>
        </ListBrandsProvider>
    )
}

export default ListBrandsPage